import type { SxProps, Theme } from "@mui/material";
import { Box, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";

interface Props {
  isLoading?: boolean;
  sx?: SxProps<Theme>;
  withTopBorder?: boolean;
}

const EntitySection = ({ isLoading, sx, withTopBorder, children }: PropsWithChildren<Props>) => (
  <Stack
    spacing={1.5}
    sx={[
      {
        border: 1,
        borderTop: withTopBorder ? 1 : 0,
        borderRadius: "4px",
        borderColor: "divider",
        bgcolor: "background.default",
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {isLoading ? (
      <Box sx={{ height: "8rem" }}>
        <InlineLoader />
      </Box>
    ) : (
      children
    )}
  </Stack>
);

export default EntitySection;
